import CoreGlobalNavigationFooter from './CoreGlobalNavigationFooter';

export { type CoreGlobalNavigationFooterProps } from './CoreGlobalNavigationFooter';
export default CoreGlobalNavigationFooter;
